export default "__VITE_ASSET__CDwQtUR4__"